// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".name {\n\t/*font-family: 'Great Vibes', cursive;*/\n\tfont-size: 70px;\n\tfont-size: calc(24px + 3vw);\n\t/*font-weight: bold;*/\n\t/*padding: 10px;*/\n\tmargin-left: 10px;\n\tmargin-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
